import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 35000,
});

apiClient.interceptors.request.use((config) => {
  let token = '';
  const user = localStorage.getItem('user');
  if (user) {
    try {
      token = JSON.parse(user)?.token || '';
    } catch (e) { /* noop */ }
  }
  if (token && config.headers) config.headers['AuthorizationToken'] = token;
  return config;
});

class AgentService {
  async getAgents() {
    const { data } = await apiClient.get('/agents');
    return data;
  }

  async createAgent({ name, email, password, phone, platformSharePercent }) {
    const { data } = await apiClient.post('/agents', {
      name,
      email,
      password,
      phone,
      platformSharePercent,
    });
    return data;
  }

  async updateAgentPlatformShare(agentId, platformSharePercent) {
    const { data } = await apiClient.put(`/agents/${agentId}/platform-share`, {
      platformSharePercent,
    });
    return data;
  }

  async toggleAgentActive(agentId) {
    const { data } = await apiClient.put(`/agents/${agentId}/deactivate`);
    return data;
  }

  async getAgentDashboard(agentId) {
    const { data } = await apiClient.get(`/agents/${agentId}/dashboard`);
    return data;
  }

  async getPendingAgentEarnings() {
    const { data } = await apiClient.get('/agents/pending-earnings');
    return data;
  }

  async payoutAgent(agentId, notes = '') {
    const { data } = await apiClient.post('/agents/payout', { agentId, notes });
    return data;
  }

  async getAgentPayoutHistory(agentId) {
    const { data } = await apiClient.get(`/agents/${agentId}/payout-history`);
    return data;
  }

  async getAllAgentPayoutHistory() {
    const { data } = await apiClient.get('/agents/payout-history-all');
    return data;
  }
}

const agentService = new AgentService();
export default agentService;
